import React, { useEffect, useMemo, useState } from "react";

import { Eye, PencilSimple, Trash } from "phosphor-react";
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

// import { API } from "../../api/SampleResponse";
import API from "../../api";
import { Button, PageBreadCrumbs, SkeletonTableView, TableView, Tooltip } from "../../components";
import { CAMPAIGN_TABS } from "./constants";
import { DataType } from "../../GlobalConstants";

export const CampaignManagement = () => {
    const [activeCampaignTab, setActiveCampaignTab] = useState(CAMPAIGN_TABS.ACTIVE.key)
    const [campaignData, setCampaignData] = useState(null)
    const [campaignLoading, setCampaignLoading] = useState(false);

    const navigate = useNavigate()

    const TableViewColumns = useMemo(() => [
        {
            name: "Campaign Id",
            field: "id",
            type: DataType.TEXT
        },
        {
            name: "Name",
            field: "name",
            type: DataType.TEXT
        },
        {
            name: "Start Date",
            field: "startDate",
            type: DataType.DATE
        },
        {
            name: "End Date",
            field: "endDate",
            type: DataType.DATE
        },
        {
            name: "Modified At",
            field: "updatedAt",
            type: DataType.DATE
        },
        {
            name: "Modified By",
            field: "updatedBy",
            type: DataType.TEXT
        },
        {
            name: "Created By",
            field: "createdBy",
            type: DataType.TEXT
        },
        {
            children: (rowData) =>
                <div className="flex items-center gap-5">
                    {
                        activeCampaignTab !== CAMPAIGN_TABS.INACTIVE.key &&
                        <Tooltip className="tooltip-primary" message="Edit Campaign" position="top">
                            <PencilSimple className="opacity-0 text-blue-500 group-hover:opacity-100" size={24} onClick={(evt) => {
                                evt?.stopPropagation()
                                if (rowData?.type && rowData?.id) {
                                    navigate(`campaign/${rowData?.id}?mode=edit`)
                                }
                            }} />
                        </Tooltip>
                    }

                    <Tooltip className="tooltip-primary" message="View Campaign" position="top">
                        <Eye className="opacity-0 text-primary group-hover:opacity-100" size={24} onClick={(evt) => {
                            evt?.stopPropagation()
                            console.log("rowData: ", rowData)
                            if (rowData?.type && rowData?.id) {
                                navigate(`campaign/${rowData?.id}?mode=view`)
                            }
                        }} />
                    </Tooltip>

                    {
                        activeCampaignTab !== CAMPAIGN_TABS.INACTIVE.key &&
                        <Tooltip className="tooltip-primary" message="Delete Campaign" position="top">
                            <Trash className="opacity-0 text-error group-hover:opacity-100" size={24} onClick={(evt) => {
                                evt?.stopPropagation();
                                if (rowData?.type && rowData?.id) {
                                    deleteCampaign({ catalogId: `${rowData?.type}`, campaignId: rowData?.id })
                                }
                            }} />
                        </Tooltip>
                    }

                </div>,
            name: DataType.ACTION,
            type: DataType.ACTION
        }], [activeCampaignTab])

    const getAllCampaigns = async ({ status, offset }) => {
        try {
            setCampaignLoading(true)
            const { items, currentPage, totalCount } = await API.getAllCampaigns({ status, offset })// pass params
            setCampaignLoading(false)
            setCampaignData({
                pagination: {
                    offset: currentPage,
                    total: totalCount,
                    pageSize: 50
                },
                data: items
            })
        } catch (err) {
            console.log("Error response: ", err)
            setCampaignLoading(false)
        }
    }
    const pageChangehandler = async ({ offset }) => {
        try {
            setCampaignLoading(true)
            const { items, currentPage, totalCount } = await API.getAllCampaigns({
                offset,
                status: activeCampaignTab?.toLowerCase()
            })// pass params

            setCampaignLoading(false)
            setCampaignData({
                pagination: {
                    offset: currentPage,
                    total: totalCount,
                    pageSize: 50
                },
                data: items
            })
        } catch (err) {
            console.log("Error message: ", err)
            setCampaignLoading(false)
        }
    }

    const deleteCampaign = async ({ campaignId, catalogId }) => {
        try {
            if (confirm("Are you sure you want to delete?")) {
                const response = await API.deleteCampaignById({ campaignId, catalogId })
                if (response?.catalogInstanceDetails?.status === "SUCCESS") {
                    toast.success('Campaign deleted successfully', {
                        position: "bottom-right"
                    })

                    getAllCampaigns({ status: activeCampaignTab?.toLowerCase(), offset: 0 })
                } else {
                    toast.error('Unable to delete Campaign', {
                        position: "bottom-right"
                    })
                }
            }
        } catch (err) {
            console.log("deleteCampaign err: ", err)
        }
    }

    useEffect(() => {
        //Get campaigns for campaign tab type
        getAllCampaigns({ status: activeCampaignTab?.toLowerCase(), offset: 0 })
    }, [activeCampaignTab])

    return (
        <div className="w-full h-full flex flex-col gap-2 relative p-4 px-8">
            <div className="w-full flex items-center justify-between">
                <PageBreadCrumbs />
                <Button variant="primary" className={"text-base"} onClick={() => {
                    navigate("create")
                }}>
                    Create Campaign
                </Button>

            </div>
            <div className="h-[90%] flex flex-col gap-4">
                <div role="tablist" className="tabs tabs-bordered items-start w-1/2">
                    {
                        Object.entries(CAMPAIGN_TABS).map(([_, { key, value }], index) => (
                            <React.Fragment key={key}>
                                <input
                                    type="radio"
                                    name="my_tabs_1"
                                    role="tab"
                                    className="tab min-w-40 text-base"
                                    aria-label={`${value}`}
                                    checked={activeCampaignTab === key}
                                    onChange={(evt) => {
                                        evt?.stopPropagation();
                                        setActiveCampaignTab(key)
                                    }}
                                    onClick={(evt) => {
                                        evt?.stopPropagation();
                                        setActiveCampaignTab(key)
                                    }}
                                />
                            </React.Fragment>
                        ))
                    }
                </div>
                <div className="overflow-x-auto h-full">
                    {
                        campaignLoading ?
                            <SkeletonTableView columCount={9} rowCount={10} />
                            :
                            <TableView
                                data={campaignData?.data}
                                pagination={campaignData?.pagination}
                                columns={TableViewColumns}
                                onPageChange={pageChangehandler}
                            />
                    }
                </div>
            </div>

        </div>
    )
}

export { NewCampaign } from "./NewCampaign";
export { ViewCampaign } from "./ViewCampaign";
export { AttachRules } from "./AttachRules"